export default "__VITE_ASSET__LNGIDig9__"